import { Button, Form, notification } from 'antd';
import { AuthChangePassPayload, useChangePassMutation } from 'app/services/edpApiV1/auth';
import { EmailField, PasswordField } from 'shared/ui/form';
import { useCallback, useEffect, useState } from 'react';
import { divideToPairs } from 'shared/helpers/utils';
import { clientCookies } from 'shared/lib';
import { useNavigate } from 'react-router-dom';
import style from './index.module.scss';

export const ChangePasswordForm = () => {
  const [changePass, { isLoading }] = useChangePassMutation();
  const [email, setEmail] = useState('');
  const [dividedEmail, setDividedEmail] = useState<string[]>([]);
  const [newPassword, setnewPassword] = useState('');
  const [newPasswordEkran, setNewPasswordEkran] = useState('');
  const [newPasswordRepeat, setnewPasswordRepeat] = useState('');
  const [form] = Form.useForm();
  const [valid, setValid] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (payload: AuthChangePassPayload) => {
    try {
      const { email, newPassword, oldPassword } = payload;
      const result = await changePass({ email, newPassword, oldPassword }).unwrap();
      clientCookies.setCredentials(result);
      navigate('/home');
    } catch (e: any) {
      notification.error({ message: e.data.message });
    }
  };

  useEffect(() => {
    const ekraned = newPassword.replace(/\*/g, '\\*').replace(/\$/g, '\\$').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
    setNewPasswordEkran(ekraned);
  }, [newPassword]);

  useEffect(() => {
    setDividedEmail(divideToPairs(email));
  }, [email]);

  const updateValidate = () => {
    try {
      form
        .validateFields({ validateOnly: false })
        .then(data => setValid(true))
        .catch(e => setValid(false));
    } catch (e) {
      console.log(e);
    }
  };

  const onNewPasswordChange = (val: string) => {
    setnewPassword(val);
    updateValidate();
  };
  const onEmailChange = (val: string) => {
    setEmail(val);
    updateValidate();
  };
  const onNewPasswordRepeatChange = (val: string) => {
    setnewPasswordRepeat(val);
    updateValidate();
  };

  const getPasswordMatchPattern = useCallback(() => {
    try {
      return new RegExp(`^${newPasswordEkran}$`);
    } catch (e) {
      notification.error({ message: 'Некорректный вид пароля' });
    }
  }, [newPasswordEkran]);

  try {
    return (
      <div className={style.root}>
        <Form form={form} className={style.form} size="large" onFinish={onFinish}>
          <h1 className={style.header}>Смена пароля</h1>
          <EmailField onChange={onEmailChange} />
          <PasswordField name="oldPassword" placeholder="Введите старый пароль" toValidate={false} />
          <PasswordField
            name="newPassword"
            placeholder="Введите новый пароль"
            onChange={onNewPasswordChange}
            rules={[
              {
                pattern: new RegExp(`^(?!.*(${dividedEmail.join('|')})).*$`),
                message: 'Пароль не должен содержать два подряд идущих символа из логина',
              },
            ]}
          />
          <PasswordField
            name="newPasswordRepeat"
            placeholder="Повторите новый пароль"
            rules={[
              {
                pattern: getPasswordMatchPattern(),
                message: 'Введенные пароли не совпадают',
              },
            ]}
            onChange={onNewPasswordRepeatChange}
          />

          <Button loading={isLoading} type="primary" className={style.button} htmlType="submit" disabled={!valid}>
            Принять
          </Button>
        </Form>
      </div>
    );
  } catch (e) {
    return null;
  }
};
